<template>
  <!-- content START here -->
  <div id="content">
    <!-- container START here -->
    <div class="container">
      <!-- main-colum START here -->
      <div id="main-colum">
        <a
          href="https://affiliates.betanysports.eu/tracking/Affiliate.aspx?idBook=3&mediaTypeID=11777&AffUrlID=1606&LandingPageID=18"
          target="_top"
        >
          <img
            src="https://affiliates.betanysports.eu/tracking/banner.aspx?idBook=3&mediaTypeID=11777&AffUrlID=1606&LandingPageID=18"
            hspace="0"
            vspace="0"
            border="0"
            alt="Bet at Betanysports.eu"
          /></a>
        <!-- CODE ENDS HERE -->
        <!-- <adsense -->
        <!--   ad-style="display:block;height:120px" -->
        <!--   ad-client="ca-pub-8213113866781504" -->
        <!--   ad-slot="7225025157" -->
        <!--   ad-format="auto" -->
        <!-- > -->
        <!-- </adsense> -->
        <br />
        <pick v-for="p in picks" :key="p.id" :pick="p"></pick>
        <div v-if="picks && picks.length === 0">
          <p>
            There are no picks currently posted. To receive picks immediately
            when they are posted, please set up pick notifications in the
            <router-link :to="{ path: '/myaccount' }">
              my account section (premium members only).
            </router-link>
          </p>
          <p>
            Get the lowest juice at BetOnline,
            <a
              href="https://record.commission.bz/_k86Ic18Yvp1qkvbhkiKqDGNd7ZgqdRLk/1/"
              target="_blank"
            >sign up here and receive a 50% bonus!</a>
          </p>
        </div>
        <br />
        <br />
        <adsense
          ad-client="ca-pub-8213113866781504"
          ad-slot="7567805932"
          ad-layout-key="-71-1m-75+i4+5r"
          ad-format="fluid"
        >
        </adsense>
      </div>
      <!-- main-colum END here -->
      <sidebar :testimonial="testimonial"></sidebar>
    </div>
    <!-- container END here -->
  </div>
  <!-- content END here -->
</template>

<script>
import Sidebar from "../components/sidebar.vue";
import Pick from "../components/pick.vue";
import TestimonialRepository from "../data/testimonial.repository.js";
import Adsense from "../components/adsense.vue";
export default {
  components: {
    sidebar: Sidebar,
    pick: Pick,
    adsense: Adsense,
  },
  data() {
    return {
      testimonial: {},
    };
  },
  computed: {
    picks() {
      return this.$store.getters.picks();
    },
  },
  created() {
    TestimonialRepository.getTestimonials(1).then((test) => {
      this.testimonial = test;
    });
  },
  metaInfo: {
    title: "Free Picks",
  },
};
</script>

<style lang="css" scoped></style>



// WEBPACK FOOTER //
// FreePicks.vue?71e000b4